import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dropzone from 'dropzone';
import XLSX from 'xlsx';
import CanvasDataGrid from 'canvas-datagrid';

import numeral from 'numeral';
import moment from 'moment';

import BlankState from '../../components/BlankState';
import UpdatePolicyInformation from '../../components/UpdateUploadedPolicy';
import Loader from '../../images/ajax-load-big.gif';
import DataTable from '../../components/DataTable';
import Page from '../../components/Page';
import Modal from '../../components/Modal';
import { TabHolder, Tab } from '../../components/Tabs';

import { uploadPolicyFile, listPoliciesUploaded } from '../../actions/policies';

import { listInsurers } from '../../actions/insurers';
import Utils from './../../utils/mci-utils';

import uploadTemplate from '../../docs/final-upload-template-may-2018.xlsm';

class UploadPolicies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedData: [],
      policy: {},
      error: [],
      active_excel_upload_policy: {},
      isSubmitted: false,
      uploaded_policies: [],
      uploaded_policies_loading: true,
      active_uploaded_policy: {}
    };
    // this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const { listPoliciesUploaded, listInsurers, user } = this.props;

    if (user.userInfo.roles[0] === 'insurer_association_admin') {
      this.setState({
        isIITAdmin: true
      });
      listInsurers();
    }

    listPoliciesUploaded();
    let canvasGrid;
    const MCIDropzone = new Dropzone('div#mci-dropzone', {
      url: '/',
      acceptedFiles: '.xls, .xlsx, .xlsm, .xslb, .csv',
      uploadMultiple: false
    });
    MCIDropzone.on('addedfile', file => {
      console.log('Added file: ', file);
      this.setState({
        ...this.state,
        file: {
          filedata: file
        }
      });
      const fileReader = new FileReader();
      let HTMLOUT = document.getElementById('htmlout');
      fileReader.onload = evt => {
        const binaryString = evt.target.result;
        const workbook = XLSX.read(binaryString, {
          type: 'binary',
          cellDates: true,
          cellNF: false,
          cellText: false
        });
        let ws = workbook.Sheets[workbook.SheetNames[0]];

        let data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        /* update canvas-datagrid */
        if (!this.canvasGrid)
          this.canvasGrid = CanvasDataGrid({ parentNode: HTMLOUT, data: data });
        this.canvasGrid.style.height = '100%';
        this.canvasGrid.style.width = '100%';
        this.canvasGrid.data = data;
      };
      fileReader.readAsBinaryString(file);
    });
  }

  editUploadedPolicy(policy) {
    console.log(policy);
    this.setState({ active_uploaded_policy: policy });
  }
  editExcelUploadedPolicy(policy) {
    this.setState({ active_excel_upload_policy: policy });
  }

  onChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  };

  onSubmit = e => {
    const { listPoliciesUploaded } = this.props;
    e.preventDefault();
    const { user } = this.props;
    const insurer = user.userInfo.insurer || this.state.insurer;

    if (!this.canvasGrid) return;
    /* convert canvas-datagrid data to worksheet */
    let new_ws = XLSX.utils.aoa_to_sheet(Utils.prep(this.canvasGrid.data));
    let new_wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(new_wb, new_ws, 'SheetJS');
    const resultJson = Utils.to_json(new_wb);

    const data = JSON.parse(resultJson);
    let result = [];
    data.map(item => {
      const fixed = {};
      const keys = Object.keys(item);
      keys.map(key => {
        if (key === 'IMPORT / EXPORT')
          return (fixed['transaction_type'] = item[key]);
        if (key === 'COVER ISSUE DATE ')
          return (fixed['date_issued'] = item[key] = moment(item[key]).format(
            'YYYY-MM-DD'
          ));
        if (key === 'OPEN COVER (YES or NO)')
          return (fixed['open_cover'] = item[key] === 'YES' ? true : false);
        if (key === 'ICC CLASS (ICC-A, ICC-B or ICC-C)')
          return (fixed['icc'] = item[key]);
        if (key === 'INSURED EMAIL ADDRESS')
          return (fixed['insured_email'] = item[key]);
        if (key === 'BROKER / AGENT NAME')
          return (fixed['intermediary_name'] = item[key]);
        if (key === 'BROKER / AGENT TIN')
          return (fixed['intermediary_tin'] = item[key]);
        if (key === 'CATEGORY OF GOODS  [SEE REF - 1]')
          return (fixed['goods_category'] = item[key]);
        if (key === 'COUNTRY OF ORIGIN/ EXPORT CODE [SEE REF - 2]')
          return (fixed['country_of_origin'] = item[key]);
        if (key === 'CURRENCY CODE [SEE REF - 3]')
          return (fixed['currency_code'] = item[key]);
        if (key === 'SUM INSURED - TZS')
          return (fixed['sum_insured'] = item[key]);
        if (key === 'PREMIUM CHARGED (VAT Inclusive) - TZS')
          return (fixed['premium'] = item[key]);
        if (key === 'VAT AT 18% - TZS') return (fixed['VAT'] = item[key]);

        if (key === 'COVER START DATE')
          return (fixed['cover_start_date'] = item[key] = moment(
            item[key]
          ).format('YYYY-MM-DD'));
        if (key === 'COVER ISSUE DATE')
          return (fixed['date_issued'] = item[key] = moment(item[key]).format(
            'YYYY-MM-DD'
          ));
        if (key === 'TANZANIA INLAND DESTINATION')
          return (fixed['destination'] = item[key]);

        fixed[key.toLocaleLowerCase().replace(/ /g, '_')] = item[key];
      });

      result.push(fixed);
    });
    const validate = Utils.checkArray(result, [
      'date_issued',
      'transaction_type',
      'policy_number',
      'open_cover',
      'endorsement_number',
      'icc',
      'insured_name',
      'insured_email',
      'insured_tin',
      'intermediary_name',
      'intermediary_tin',
      'goods_category',
      'country_of_origin',
      'destination',
      'conveyance',
      'financier',
      'currency_code',
      'exchange_rate_used',
      'sum_insured',
      'premium',
      'VAT',
      'unit_of_measure',
      'quantity',
      'cover_start_date'
    ]);
    if (validate) {
      const reqData = {
        filedata: result,
        insurer: insurer
      };
      //console.log(JSON.stringify(reqData, 2, 2));
      this.props.uploadPolicyFile(reqData);
      this.canvasGrid.remove();
    } else {
      alert('Use the correct excel template!');
      return;
    }
  };

  render() {
    const menuItems = [
      { id: 'all-users', name: 'All Uploaded Policies', active: true },
      { id: 'add-user', name: 'Upload Policies' }
    ];

    const { active_uploaded_policy, active_excel_upload_policy } = this.state;

    const { policies, insurers } = this.props;
    const uploads = this.state.uploadedData;
    return (
      <Page isAdminPage={true} pageTitle="Uploaded Policies">
        <div className="clearfix">
          <TabHolder menuItems={menuItems}>
            <Tab menuId={menuItems[0].id} isActive={true}>
              {policies.uploaded_policies.length > 0 ? (
                <DataTable
                  tableId="users-table"
                  columnTitles={[
                    'Date Created',
                    'Created By',
                    'Proposer Name',
                    'Country',
                    'Policy Number',
                    'Premium',
                    'Sum Insured',
                    'TIN',
                    'Start Date',
                    'ICC Class',
                    'Description',
                    'Uploaded Successfully',
                    'Actions'
                  ]}
                >
                  {policies.uploaded_policies.map((policy, index) => {
                    let policyInfo = policy.policy;

                    return (
                      <tr key={index}>
                        <td>
                          {moment(policyInfo.date_created).format(
                            'MMM Do, YYYY'
                          )}
                        </td>
                        <td>{policy.creator}</td>
                        <td>{policyInfo.proposer_name}</td>
                        <td>{policyInfo.country_from_name}</td>
                        <td>{policyInfo.policy_number}</td>
                        <td>{numeral(policyInfo.premium).format('0,0.00')}</td>
                        <td>
                          {numeral(policyInfo.total_sum_insured).format(
                            '0,0.00'
                          )}
                        </td>
                        <td>{policyInfo.tra_pin}</td>
                        <td>
                          {moment(policyInfo.start_date).format('MMM Do, YYYY')}
                        </td>
                        <td>{policyInfo.institute_cargo_clause}</td>
                        <td>{policy.description}</td>
                        <td>
                          {policy.is_processed ? (
                            <span className="label label-success">Yes</span>
                          ) : (
                            <span className="label label-danger">No</span>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn btn-primary btn-block"
                            data-toggle="modal"
                            data-target=".update-policy-information"
                            onClick={() => {
                              this.editUploadedPolicy(policy);
                            }}
                          >
                            {policy.is_processed
                              ? 'Edit Details'
                              : 'Edit & Complete Upload'}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={policies.uploaded_policies}
                  dataName="Uploaded Policies"
                  isDataLoading={policies.uploaded_policies_loading}
                />
              )}

              <Modal
                title="Update Policy Information"
                className="update-policy-information"
                closable={true}
              >
                <UpdatePolicyInformation
                  edit={true}
                  policy_info={active_uploaded_policy}
                />
              </Modal>
            </Tab>

            <Tab menuId={menuItems[1].id}>
              <form className="form" onSubmit={this.onSubmit}>
                <div
                  className="alert alert-info"
                  style={{ marginBottom: '2em' }}
                >
                  <p>Use the policy upload template below for data entry:</p>
                  <a href={uploadTemplate} className="download-link">
                    <i className="icon ion-ios-download-outline" />
                    Download Policy Uploads Template
                  </a>
                </div>

                <div className="messages">
                  {policies.uploadSuccess ? (
                    <div className="alert alert-success" role="alert">
                      {policies.successMessage}
                    </div>
                  ) : null}
                  {policies.uploadError ? (
                    <div className="alert alert-danger" role="alert">
                      {policies.errorMessage}
                    </div>
                  ) : null}
                </div>
                {policies.uploading ? <img src={Loader} alt="img" /> : null}
                {this.state.isIITAdmin ? (
                  <div className="form-group has-feedback">
                    <label className="control-label col-md-12">
                      Select Insurer <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-12">
                      <select
                        className="form-control"
                        name="insurer"
                        onChange={this.onChange}
                        required
                      >
                        <option value="" disabled>
                          --Select Insurance Company--
                        </option>
                        {insurers.insurers.map(insurer => {
                          return (
                            <option key={insurer.id} value={insurer.id}>
                              {insurer.company_name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                ) : null}

                <div className="row">
                  <div className="form-group col-md-6">
                    <div
                      className="mci-dropzone clearfix col-md-12"
                      id="mci-dropzone"
                    >
                      Click to select Excel File with Policies
                    </div>
                    <p>
                      {false ? (
                        <input
                          name="filedata"
                          type="file"
                          accept="*.xlsx *.xlsm"
                        />
                      ) : null}
                    </p>

                    <button
                      type="submit"
                      className="btn btn-primary btn-block"
                      style={{ marginTop: '2em' }}
                    >
                      <i className="icon ion-plus" /> Upload Policies
                    </button>
                  </div>
                  <div className="col-md-6">
                    <div
                      className="alert alert-warning"
                      style={{ marginBottom: '2em' }}
                    >
                      <p>
                        <span>
                          <i className="icon ion-android-alert" />{' '}
                        </span>
                        Please make sure you do not have any empty cells on the
                        Excel sheet below. (You can edit and fill in the missing
                        information in the sheet below).
                      </p>
                    </div>
                  </div>
                </div>
                <div id="htmlout" />
              </form>
            </Tab>
          </TabHolder>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  insurers: state.insurers,
  policies: state.policies
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { uploadPolicyFile, listPoliciesUploaded, listInsurers },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadPolicies);



// WEBPACK FOOTER //
// ./src/pages/dashboard/UploadPolicies.js